import * as React from 'react';
import { useFormField } from '../../../utils';
export var useMultiselectControls = function useMultiselectControls(props) {
  var _useFormField = useFormField({
    name: props.name
  }),
      touched = _useFormField.meta.touched,
      _useFormField$helpers = _useFormField.helpers,
      setTouched = _useFormField$helpers.setTouched,
      setValue = _useFormField$helpers.setValue;

  var handleMultiSelect = React.useCallback(function (values) {
    setValue(values);

    if (!touched) {
      setTouched(true);
    }
  }, [setTouched, setValue, touched]);
  return {
    handleMultiSelect: handleMultiSelect
  };
};